<template>
    <form id="schritt4form" novalidate>
      <div class="my-4"> 
          <div class="bgTR px-4 px-lg-5 py-4 py-lg-5 justify-content-">
              <div class="schritt-zaehler-position">
                  <SchritteZaehler class="w-100"></SchritteZaehler>
              </div>
              <h3 class="pb-3 w-100 text-start">Abschluss des Vertrages</h3>    
  
              
              
                  <div class="w-100">
                      <RdnummerOk 
                                v-if="shouldShowRdnummerInfo" 
                                :rdnummer="store.aok"                               
                              />
                  </div>
                  <!-- Charity Informationen -->
                  <div class="card border-0 bg-transparent">
      <div class="mt-3 font-base-links">
  
        <!-- Title -->
        <h6 class="font-lg-links-bold mb-1">
          <em>vigo</em>-CHARITY / Beratungsdokumentation
        </h6>
  
        <!-- Intro -->
        <p class="mb-3">
          Beratung vom {{ heutigesDatum }} für die Beantragung der Zusatztarife der
          <em><b>vigo</b></em> Krankenversicherung VVaG.<br />
          Die Beratung erfolgte zwischen der <b>AOK Rheinland/Hamburg</b> und <b>{{ vnName }}</b>.
        </p>
  
        <!-- Beratung erfolgte -->
        <div class="mb-3">
          <div class="form-group">
            <div>
              <div class="d-block d-md-inline">Die Beratung erfolgte</div>
              <div class="d-block d-sm-inline mt-2 mt-md-0">
                <span class="d-none d-md-inline" style="margin-left: 2rem !important">&nbsp;</span>
                <input type="radio" v-model="store.beratungsart" class="form-check-input" id="beratungsartTel" name="beratungsart" value="1"> 
                <label class="form-check-label ms-2" for="beratungsartTel">per Telefon/digital</label>
              </div>
              <div class="d-block d-sm-inline mt-2 mt-sm-0">
                <span class="d-none d-sm-inline" style="margin-left: 2rem !important">&nbsp;</span>
                <input type="radio" v-model="store.beratungsart" class="form-check-input" id="beratungsartPers" name="beratungsart" value="2"> 
                <label class="form-check-label ms-2" for="beratungsartPers">persönlich vor Ort</label><span class="d-none d-md-inline">.</span>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Anlass der Beratung -->
        <div class="mb-4">
          <span class="font-lg-links-bold d-block mb-2">Anlass der Beratung</span>
          <div>Ergänzung der gesetzlichen Kranken- und Pflegeversicherung</div>
        </div>
  
        <!-- Empfehlung und Begründung -->
        <div class="mb-4">
          <span class="font-lg-links-bold d-block mb-2">Empfehlung und Begründung</span>
          <div class="form-group">
            <div class="form-check form-check-inline">
              <input type="checkbox" class="form-check-input" id="bd-empfehlung" name="bd-empfehlung" :checked="store.kundenentscheid === 0" @click="updateKundenentscheid(0, $event)">
              <label class="form-check-label" for="bd-empfehlung">
                Die Beratung erfolgte unter Einbeziehung der erhobenen Risikomerkmale und verfügbaren Tarife der <em><b>vigo</b></em> Krankenversicherung VVaG (insb. die <em><b>vigo</b></em> select-Tarife Zahnvorsorge Basis/Premium, Zahnersatz x2 sowie Ein-/Zweibettzimmer). 
                Der aufgenommene Antrag entspricht dem geäußerten Kundenwunsch.
              </label>
            </div>
          </div>
        </div>
  
        <!-- Abweichende Kundenentscheidung -->
        <div class="mb-4">
          <span class="font-lg-links-bold d-block mb-2">Abweichende Kundenentscheidung</span>
          <div class="form-group">
            <div class="form-check form-check-inline">
              <input type="checkbox" class="form-check-input" id="bd-abweichung" name="bd-abweichung" :checked="store.kundenentscheid === 1" @click="updateKundenentscheid(1, $event)">
              <label class="form-check-label" for="bd-abweichung">
                Der Kunde ist der Empfehlung nicht oder nur bedingt gefolgt und wurde darüber aufgeklärt, dass evtl. kein Versicherungsschutz besteht. Die genannten Gründe für die Abweichung sind im Feld „Anmerkungen" zu erfassen.
              </label>
            </div>
          </div>
        </div>
  
        <!-- Anmerkungen -->
        <div class="form-group">
          <label class="form-label font-lg-links-bold" for="anmerkungen">
            Anmerkungen
          </label>
          <textarea
            id="anmerkungen"
            name="anmerkungen"            
            class="form-control border border-2 rounded rounded-lg"
            placeholder=""
            v-model="store.abweichendText"
            rows="4" 
            :readonly="store.kundenentscheid === 0"
          ></textarea>
          <br><span id="anm-counter"></span>
        </div>

        
  
      </div>
    </div>
              
              
  
              <div class="boxTR mt-1 px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                  <!-- Hinweise -->
        <div class="mb-4">
          <span class="font-lg-links-bold d-block mb-2">Hinweise *</span>
          <div class="form-group">
            <div class="form-check form-check-inline">
              <input v-model="store.vollstaendig" type="checkbox" class="form-check-input" id="bd-vollstaendig" name="bd-vollstaendig">
              <label class="form-check-label" for="bd-vollstaendig">
                Auf die Wichtigkeit zum vollständigen und wahrheitsgemäßen Ausfüllen des Antragsformulars wurde der Kunde hingewiesen. Dem Kunden ist bekannt, dass Falschangaben seinen Versicherungsschutz gefährden können.
              </label>
            </div>
          </div>
        </div>

        <!-- Einwilligungserklärungen und Bestätigung der Kenntnisnahme zum Versicherungsschutz -->
        <div>
          <span class="font-lg-links-bold d-block mb-2">Einwilligungserklärungen und Bestätigung der Kenntnisnahme zum Versicherungsschutz *</span>
          <div class="form-group">
            <div class="form-check form-check-inline">
              <input type="checkbox" v-model="store.eweWillenserklaerung" class="form-check-input" id="bd-willenserklaerung" name="bd-willenserklaerung">
              <label class="form-check-label" for="bd-willenserklaerung">
                Der Kunde bestätigt, dass der Antrag seinem Willen entspricht. Die „Vertragsgrundlagen und Erklärungen des Antragstellers und der zu versichernden Person(en)", die „Wesentlichen Informationen" (einschließlich der Vertragsbestimmungen und der Allgemeinen Versicherungsbedingungen), die Einwilligung in die Erhebung und Verwendung der Gesundheitsdaten, Sozialdaten der AOK Rheinland/Hamburg, die Schweigepflichtentbindungserklärung hat der Kunde erhalten und erkennt diese an.
              </label>
            </div>
          </div>
        </div>
              </div>

              <div class="boxTR mt-4 px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                                            <span class="font-weight-bold">Nach Beratung zu den <i>vigo</i> select Tarifen wurde die folgende Tariflösung gewählt:</span>
                                            <div v-if="store.hatZVS()" style="margin-top: 1rem; margin-bottom: 1rem;">
                                                <strong><i>vigo</i> select Zahnvorsorge Basis:</strong> Durch die Zahnzusatzversicherung vigo select Zahnvorsorge Basis werden bei Zahnvorsorge und Zahnbehandlung Lücken des gesetzlichen Krankenversicherungsschutzes geschlossen bzw. reduziert. Wir erstatten Kosten für professionelle Zahnreinigung (PZR), Prophylaxe und Füllungen. Für Versicherungsfälle, die vor Beginn des Versicherungsschutzes eingetreten sind, leisten wir nicht. Dazu zählen alle Maßnahmen, die zum Zeitpunkt des Vertragsschlusses stattfinden, notwendig, geplant oder (zahn)ärztlich angeraten sind (Ausnahmen: Prophylaxe einschließlich der professionellen Zahnreinigung). Auf eine geltende Leistungsstaffel innerhalb der ersten drei Versicherungsjahre wurde hingewiesen.                                                                                                     
                                            </div>
                                            <div v-if="store.hatZVP()" style="margin-top: 1rem; margin-bottom: 1rem;">
                                                <strong><i>vigo</i> select Zahnvorsorge Premium:</strong>  Durch die Zahnzusatzversicherung vigo select Zahnvorsorge Premium werden bei Zahnvorsorge und Zahnbehandlung Lücken des gesetzlichen Krankenversicherungsschutzes geschlossen bzw. reduziert. Wir erstatten Kosten u.a. für professionelle Zahnreinigung, Prophylaxe, Füllungen, Kieferorthopädie, sowie für Parodontose- und Wurzelbehandlungen. Für Versicherungsfälle, die vor Beginn des Versicherungsschutzes eingetreten sind, leisten wir nicht. Dazu zählen alle Maßnahmen, die zum Zeitpunkt des Vertragsschlusses stattfinden, notwendig, geplant oder (zahn)ärztlich bzw. kieferorthopädisch angeraten sind (Ausnahmen: Prophylaxe einschließlich der professionellen Zahnreinigung). Auf eine geltende Leistungsstaffel innerhalb der ersten drei Versicherungsjahre wurde hingewiesen.                                                
                                            </div>
                                            <div v-if="store.hatZX2()" style="margin-top: 1rem; margin-bottom: 1rem;">
                                                <strong><i>vigo</i> select Zahnersatz x2:</strong> Durch die Zahnzusatzversicherung vigo select Zahnersatz x2 werden bei Zahnersatzmaßnahmen Lücken des gesetzlichen Krankenversicherungsschutzes geschlossen. Der Tarif ermöglicht eine Verdopplung des GKV-Festzuschusses bis zum Betrag der Gesamtrechnung. Für Versicherungsfälle, für die vor Abschluss des Versicherungsvertrages oder vor Ablauf der Wartezeit ein Heil- und Kostenplan erstellt wurde, besteht kein Versicherungsschutz. Auf eine geltende Leistungsstaffel innerhalb der ersten drei Versicherungsjahre sowie eine Wartezeit von 6 Monaten wurde hingewiesen.                                                
                                            </div>
                                            <div v-if="store.hatStationaer()" style="margin-top: 1rem; margin-bottom: 1rem;">
                                                <strong><i>vigo</i> select Ein-/Zweibettzimmer:</strong> Durch die stationäre Zusatzversicherung vigo select Ein-/Zweibettzimmer wird die gesonderte Unterbringung im Krankenhaus erstattet. Es werden u.a. die gesonderten Unterbringungskosten und gesetzliche Zuzahlungen erstattet. Für Versicherungsfälle, die vor Abschluss des Versicherungsvertrages eingetreten sind, leisten wir nicht. Was bedeutet das? Krankheiten, die in den letzten 2 Jahren vor Versicherungsbeginn bestanden und für die eine stationäre Behandlung in dieser Zeit bereits eine Behandlungsoption darstellte, werden vom Versicherungsschutz nicht erfasst. Auf die allgemeine Wartezeit von 3 Monaten bzw. die besondere Wartezeit für Entbindung, Psychotherapie und Zahnersatz von 8 Monaten wurde hingewiesen.                                            
                                            </div>
                                        </div>  
  
              <div class="v4y-einwilligung-box mt-4 w-100">
                  <div class="mx-4 py-3">
                      <div class="pb-3">
                          <b>Einwilligungserklärung zu Kontaktzwecken (optional)</b>
                      </div>
                      <div class="form-group">
                          <div class="form-check form-check-inline">
                              <input class="form-check-input" type="checkbox" id="eweKontakt" name="eweKontakt" v-model="store.eweKontakt">
                              <label class="form-check-label" for="eweKontakt">
                                  Ich willige ein, dass mich die <em><b>vigo</b></em> Krankenversicherung und ihre Vermittler telefonisch und per E-Mail über Versicherungsprodukte informieren dürfen. Dies gilt unabhängig davon, ob ein Vertrag besteht. Ein Widerruf für die Zukunft ist jederzeit möglich. 
                              </label>
                          </div>
                      </div>
                  </div>
              </div>
              
              <div class="mt-4 w-100 d-flex justify-content-end">
                  <OnlineZahlungspflichtigAbschliessenButton 
                      data-shake="true" 
                      :disabled="submitDisabled"
                      :isLoading="vertragStore.isSubmitting"
                      @click="handleAbschliessen"
                  />
              </div>
          </div>
      </div>
  
      
    </form>
  </template>
  
  <script setup>
  import { onMounted, computed, nextTick, ref } from 'vue';
  import { formValidation } from '@form-validation/bundle/popular';
  import { Bootstrap5 } from '@form-validation/plugin-bootstrap5';
  import { Trigger } from '@form-validation/plugin-trigger';
  import { useRechnerStore } from '@/stores/rechner';
  import { useMainStore } from '@/stores/useMainStore.js';
  import { useVertragStore } from '@/stores/vertrag.js';
  import { useAntragStore } from '@/stores/antrag.js';
  import { createVertrag, downloadVersicherungsschein } from '@/api/VertragService.js';
  import SchritteZaehler from '@/components/general/schritte_zaehler.vue';
import OnlineZahlungspflichtigAbschliessenButton from '@/components/online_zahlungspflichtig_abschliessen_button.vue';
import RdnummerOk from '@/components/general/rdnummer_ok.vue';
  import moment from 'moment';
  import { validatorAbweichendeKundenentscheidungText } from '@/validators/validatoren.js';
  
  const store = useRechnerStore();
  const mainStore = useMainStore();
  const vertragStore = useVertragStore();
  const antragStore = useAntragStore();
  
  let fv = null;
  
  // Computed für Button-States
  const submitDisabled = computed(() => {
    return vertragStore.hasSubmit || vertragStore.isSubmitting;
  });
  
  const shouldShowRdnummerInfo = computed(() => {
    // Nur anzeigen wenn Feature enabled UND RD-Nummer vorhanden (nicht 0)
    return mainStore.aokEnabled && store.aok !== 0
  });

  // Aktuelles Datum formatiert
  const heutigesDatum = computed(() => {
    return moment().format('DD.MM.YYYY');
  });

  // VN-Name (Vorname + Nachname)
  const vnName = computed(() => {
    const vorname = store.vndaten.vorname || '';
    const nachname = store.vndaten.nachname || '';
    return `${vorname} ${nachname}`.trim();
  });

  // Kundenentscheid-Handler (gegenseitig exklusive Checkboxen)
  const updateKundenentscheid = (value, event) => {
    if (store.kundenentscheid !== value) {
      store.kundenentscheid = value;
      // Wenn "Empfehlung" gewählt wird, Anmerkungen leeren
      if (value === 0) {
        store.abweichendText = '';
      }
    } else {
      event.preventDefault();
    }
  };
  
  // Submit-Handler
  const handleAbschliessen = async () => {
    if (!fv) return;
    
    const button = document.querySelector('[data-shake="true"]');
    
    // Validierung prüfen
    const status = await fv.validate();
    
    if (status !== 'Valid') {
      // Validation failed - shake button
      if (button) {
        button.classList.add('shake');
        setTimeout(() => button.classList.remove('shake'), 500);
      }
      nextTick(() => {
        const firstInvalid = document.querySelector('#schritt4form .is-invalid');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
      return;
    }
    
    // Validation erfolgt - API-Call starten
    console.log('[Schritt4AOK] Vertragsabschluss wird gestartet...');
    
    // Bei AOK-Abschluss: Einwilligung Sozialdaten immer auf true setzen
    // (im AOK-UI gibt es kein Feld dafür, da die Einwilligung vorausgesetzt wird)
    store.eweSozialdaten = true;
    
    // Loading-State aktivieren
    vertragStore.isSubmitting = true;
    vertragStore.resetError();
    
    try {
      // API-Call: Vertrag anlegen
      const result = await createVertrag(antragStore.antragId);
      
      if (!result.success) {
        // Fehler beim Anlegen des Vertrags
        console.error('[Schritt4AOK] Fehler beim Vertrag:', result.error);
        vertragStore.errorMessage = result.error;
        vertragStore.isSubmitting = false;
        // Navigation zu Schritt5 mit Fehleranzeige
        store.resetVertragsdokumentDownloadStatus();
       store.stepStatus = 5;
        return;
      }
      
      // Erfolg - Speichere Daten im RechnerStore
      console.log('[Schritt4AOK] Vertrag erfolgreich angelegt');
      store.vertragsnummer = result.vertragsnummer;
      store.secretstring = result.secret;
      store.antragAbgeschickt = true;
      
      // Auch im VertragStore speichern
      vertragStore.vertragsnummer = result.vertragsnummer;
      vertragStore.secretstring = result.secret;
      vertragStore.hasSubmit = true;
      
      console.log('[Schritt4AOK] Warte 5 Sekunden vor Versicherungsschein-Download...');
      
      // 5 Sekunden warten (analog zur alten Implementierung)
      await new Promise(resolve => setTimeout(resolve, 5000));
      
      // Automatischer Download des Versicherungsscheins
      console.log('[Schritt4AOK] Starte Versicherungsschein-Download...');
      const downloadResult = await downloadVersicherungsschein(result.vertragsnummer, result.secret);
      
      if (!downloadResult.success) {
        console.error('[Schritt4AOK] Versicherungsschein-Download fehlgeschlagen:', downloadResult.error);
        // Fehler wird geloggt, aber wir navigieren trotzdem weiter
        // Der User kann auf der Erfolgsseite erneut herunterladen
      }
      
      // Navigation zu Erfolgsseite
      vertragStore.isSubmitting = false;
      
      store.resetVertragsdokumentDownloadStatus();
      store.stepStatus = 5;
      
    } catch (error) {
      console.error('[Schritt4AOK] Unerwarteter Fehler:', error);
      vertragStore.errorMessage = error.message || 'Ein unerwarteter Fehler ist aufgetreten';
      vertragStore.isSubmitting = false;
      // Navigation zu Schritt5 mit Fehleranzeige
      store.resetVertragsdokumentDownloadStatus();
      store.stepStatus = 5;
    }
  };
  
  // FormValidation initialisieren
  onMounted(async () => {
      await nextTick()
      
      const formElement = document.getElementById('schritt4form');
      
      const fields = {
        beratungsart: {
          validators: {
            choice: {
              message: 'Bitte wählen Sie die Beratungsart aus.',
              min: 1,
            },
          },
        },
        anmerkungen: {
          validators: {
            checkAbweichendeKundenentscheidungText: {
              message: 'Bitte geben Sie die Gründe für die abweichende Kundenentscheidung ein.',
            },
            stringLength: {
              message: 'Bitte geben Sie maximal 300 Zeichen an.',
              max: 300,
            },
          },
        },
        'bd-vollstaendig': {
          validators: {
            choice: {
              message: 'Bitte bestätigen Sie die Hinweise.',
              min: 1,
            },
          },
        },
        'bd-willenserklaerung': {
          validators: {
            choice: {
              message: 'Bitte bestätigen Sie die Einwilligungserklärungen und Kenntnisnahme zum Versicherungsschutz.',
              min: 1,
            },
          },
        },
      };
  
      fv = formValidation(formElement, {
        locale: 'de_DE',
        fields,
        plugins: {
          bootstrap5: new Bootstrap5({
            rowSelector: '.form-group, .form-check, .form-check-inline'
          }),
          trigger: new Trigger({
            event: 'blur change',
          }),
        },
      });

      // Custom Validator registrieren
      fv.registerValidator('checkAbweichendeKundenentscheidungText', validatorAbweichendeKundenentscheidungText);
  });
  </script>
  
  <style scoped>
      .introclaim {
          margin-bottom: 1.5rem;
      }
      .platziert {
          position: absolute;
          right:0;
          top:0;
          transform: translate(-20%,-50%);
      }
  
  
      .schritt-zaehler-position {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90vw;
      }
  
      @media (min-width: 768px) {
      .schritt-zaehler-position {
          width: 80vw;
      }
      }
  
      @media (min-width: 992px) {
      .schritt-zaehler-position {
          width: 70vw;
      }
      }
  
      @media (min-width: 1200px) {
      .schritt-zaehler-position {
          width: 60vw;
      }
      }
  
      h3 {
          color: #000;
          font-family: "Source Sans Pro";
          font-size: 22px;
          font-style: normal;
          font-weight: 700;
          line-height: 160%;
          text-align: left;
      }

      /* Readonly Textarea ausgegraut */
      textarea[readonly] {
          background-color: #e9ecef;
          cursor: not-allowed;
          opacity: 0.7;
      }
  
      @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
          20%, 40%, 60%, 80% { transform: translateX(5px); }
      }
  
      .shake {
          animation: shake 0.5s ease-in-out;
      }
  </style>
